module.exports = __webpack_public_path__ + "img/signup-brands@2x.8f5698fc.png";